import React from "react";
import { Button, Modal } from "react-bootstrap";
import LoadingDisplay from "./LoadingDisplay";

interface ConfirmModalProps {
  show: boolean;
  title?: string;
  children?: any;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  disabled?: boolean;
  onOk: () => void;
  onCancel?: () => void;
}

function ConfirmModal({
  show,
  title = "Confirmation",
  children = <p>Are you sure?</p>,
  primaryButtonText = "Yes",
  secondaryButtonText = "No",
  disabled,
  onOk,
  onCancel,
}: ConfirmModalProps) {
  return (
    <Modal show={show} onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {!disabled && children}
        {disabled && <LoadingDisplay loading={true} />}
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => onCancel && onCancel()}
          disabled={disabled ?? false}
        >
          {secondaryButtonText}
        </Button>
        <Button
          variant="primary"
          onClick={() => onOk()}
          disabled={disabled ?? false}
        >
          {primaryButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmModal;
